module.exports = __webpack_public_path__ + "img/workshops_3.9bbefd5f.png";